import { useEffect } from 'react';
import { useAuthStore } from '@features/auth/store/authStore';
import { usePendingInvitationsStore } from '@features/user/invitations/store/pendingInvitationsStore';

/**
 * Shared pending-invitation count for Header badge and workspace banner.
 * Reads from the Zustand store and soft-refetches on tab visibility.
 */
export function usePendingInviteCount() {
  const total = usePendingInvitationsStore((s) => s.total);
  const loading = usePendingInvitationsStore((s) => s.loading);
  const hasLoaded = usePendingInvitationsStore((s) => s.hasLoaded);
  const fetchTotal = usePendingInvitationsStore((s) => s.fetchTotal);

  useEffect(() => {
    if (!useAuthStore.getState().isAuthenticated()) {
      return;
    }

    const { hasLoaded: loaded } = usePendingInvitationsStore.getState();
    if (!loaded) {
      void fetchTotal();
    }

    const onVisibility = () => {
      if (document.visibilityState !== 'visible') return;
      if (!useAuthStore.getState().isAuthenticated()) return;
      void fetchTotal();
    };

    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, [fetchTotal]);

  return { total, loading, hasLoaded };
}
